var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 35"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4 1L14 14.1 7.6 1 .5 15.9V33h27V15.9L20.4 1zm0 2.4l6 12.5h-12l6-12.5zm-12.8 0l6.1 12.5h-12L7.6 3.4zM13.5 32h-1.4v-7.8h1.4V32zm-1.4-8.8c0-1 .9-1.7 1.9-1.7 1 0 1.9.8 1.9 1.7h-3.8zm3.8 8.8h-1.4v-7.8h1.4V32zm10.6 0H17v-8.8c0-1.5-1.3-2.8-2.9-2.8-1.6 0-2.9 1.2-2.9 2.8V32H1.5V16.9h24.9V32z",
    className: "icon_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3 19.1h-6v8h5.9v-8zM5.8 26H4.4v-5.9h1.4V26zm2.4 0H6.8v-5.9h1.4V26zm16.5-6.9h-5.9v8h5.9v-8zM21.2 26h-1.4v-5.9h1.4V26zm2.5 0h-1.4v-5.9h1.4V26z",
    className: "icon_svg__st0"
  })));
};

export default SvgIcon;